import React from "react";
import { Provider } from "react-redux";
import Products from "./Products";
import { store } from "./store";

interface ProductsListAppProps {
  isCatalog: boolean;
  isB2B: boolean;
  isStandaloneProduct?: boolean;
}

const ProductsListApp = (props: ProductsListAppProps) => {
  return (
    <Provider store={store}>
      <Products isCatalog={props.isCatalog} isB2B={props.isB2B} isStandaloneProduct={props.isStandaloneProduct} />
    </Provider>
  );
};

export default ProductsListApp;
